import { PipeTransform } from '@angular/core';
var ConvertByValueTypePipe = /** @class */ (function () {
    function ConvertByValueTypePipe() {
    }
    ConvertByValueTypePipe.prototype.transform = function (orderProductService, companyId) {
        var productServiceCompany = orderProductService.item.productServiceCompanies.find(function (psc) { return psc.company.id === companyId; });
        var valueType = productServiceCompany.valueType;
        if (!valueType) {
            return '-';
        }
        switch (valueType) {
            case 'hour':
                return this.convertToHours(orderProductService.quantity || 0);
            case 'kilometer':
                return "" + ((orderProductService.quantity || 0) / 1000).toFixed(2);
            case 'fixed':
                return String(orderProductService.quantity || 0);
            default:
                return String(orderProductService.quantity || 0);
        }
    };
    ConvertByValueTypePipe.prototype.convertToHours = function (quantity) {
        var hours = Math.floor(quantity / 60);
        var minutes = Math.floor(quantity % 60);
        var seconds = Math.round((quantity % 1) * 60);
        return hours.toString().padStart(2, '0') + ":" + minutes
            .toString()
            .padStart(2, '0') + ":" + seconds.toString().padStart(2, '0');
    };
    return ConvertByValueTypePipe;
}());
export { ConvertByValueTypePipe };
